.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.card {
  padding: 32px 28px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-bg-card);
}

.after {
  border-color: var(--color-purple);
  background: linear-gradient(
    135deg,
    rgba(124, 58, 237, 0.12),
    rgba(12, 10, 20, 0.8)
  );
}

.label {
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-gold);
}

.text {
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-text-muted);
}

.after .text {
  color: var(--color-text);
}

@media (max-width: 640px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
